<template>
    <div :title="title" class="inline-block">
        <component v-bind="$attrs" :is="type" />
    </div>
</template>

<script>
import {
    IconActivityHeartbeat,
    IconBarcode,
    IconDelta,
    IconListDetails,
    IconListNumbers,
    IconMathXDivideY,
    IconNavigationNorth,
    IconSitemap,
} from '@tabler/icons-vue';

export default {
    name: 'QuestionIcon',
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    components: {
        'multiple-choice': IconListDetails,
        'short-answer': IconBarcode,
        'true-false': IconActivityHeartbeat,
        'order-phrase': IconSitemap,
        'order-elements': IconListNumbers,
        'math-fraction': IconMathXDivideY,
        'math-number-with-tolerance': IconDelta,
        'multiple-answer': IconListDetails,
        'math-xyz-answers': IconListDetails,
        'math-multiple-magnitudes': IconNavigationNorth,
        'math-prime-factors': IconListDetails,
        'math-polynomial-operation': IconListDetails,
        'math-latex-answer': IconListDetails,
        // { question_type_icon }
    },
    computed: {
        title: function () {
            const map = {
                'multiple-choice': this.$t('messages.question_type_multiple_choice'),
                'short-answer': this.$t('messages.question_type_short_answer'),
                'true-false': this.$t('messages.question_type_true_false'),
                'order-phrase': this.$t('messages.question_type_order_phrase'),
                'order-elements': this.$t('messages.question_type_order_elements'),
                'math-fraction': this.$t('messages.question_type_math_fraction'),
                'math-number-with-tolerance': this.$t('messages.question_type_math_number_with_tolerance'),
                'multiple-answer': this.$t('messages.question_type_multiple_answer'),
                'math-xyz-answers': this.$t('messages.question_type_math_xyz_answers'),
                'math-multiple-magnitudes': this.$t('messages.question_type_math_multiple_magnitudes'),
                'math-prime-factors': this.$t('messages.question_type_math_prime_factors'),
                'math-polynomial-operation': this.$t('messages.question_type_math_polynomial_operation'),
                'math-latex-answer': this.$t('messages.question_type_math_latex_answer'),
                // { question_type_localization }
            };

            return map[this.type];
        },
    },
};
</script>
